import { toCamelCase, toSnakeCase } from './caseMappers';
import type {
    AccountProfile,
    ApiAccountProfile,
    ApiEmailInvitation,
    ApiInvitation,
    ApiInvitationRedirect,
    ApiPartner,
    ApiPartnerConnectionType,
    ApiPartnerConnectionTypeList,
    ApiPartnerList,
    EmailInvitation,
    Invitation,
    InvitationRedirect,
    Partner,
    PartnerConnectionType,
    PartnerConnectionTypeList,
    PartnerList,
} from './partnerNetwork.types';
import { ApiPartnerSchema } from './partnerNetwork.types';

export const mapAccountProfile = (apiAccountProfile: ApiAccountProfile): AccountProfile => {
    return toCamelCase<AccountProfile>(apiAccountProfile);
};

export const mapPartner = (apiPartner: ApiPartner): Partner => {
    const base = toCamelCase<Partner>(apiPartner);

    return {
        ...base,
        accountProfile: apiPartner.account_profile && mapAccountProfile(apiPartner.account_profile),
        partnerConnectionDisplayName: apiPartner.account_profile?.display_name,
    };
};

export const mapPartnerList = (apiPartnerList: ApiPartnerList): PartnerList => {
    const validPartners = apiPartnerList.items.flatMap(apiPartner => {
        const result = ApiPartnerSchema.safeParse(apiPartner);
        if (!result.success) {
            console.warn('Ignoring invalid partner connection from API response', {
                partnerId: apiPartner.id,
                issues: result.error.issues,
            });
            return [];
        }
        return [result.data];
    });

    return {
        items: validPartners.map(mapPartner),
    };
};

export const mapPartnerConnectionType = (apiPartnerConnectionType: ApiPartnerConnectionType): PartnerConnectionType => {
    return {
        connectionType: apiPartnerConnectionType.connection_type,
        connectionFeatures: apiPartnerConnectionType.connection_features,
        displayName: apiPartnerConnectionType.display_name,
    };
};

export const mapPartnerConnectionTypeList = (
    apiPartnerConnectionTypeList: ApiPartnerConnectionTypeList
): PartnerConnectionTypeList => {
    return {
        items: apiPartnerConnectionTypeList.items.map(mapPartnerConnectionType),
    };
};

export const mapInvitation = (apiInvitation: ApiInvitation): Invitation => {
    return toCamelCase<Invitation>(apiInvitation);
};

export const mapPartnerToApi = (partner: Partner): ApiPartner => {
    return toSnakeCase<ApiPartner>(partner);
};

export const mapInvitationToApi = (invitation: Invitation): ApiInvitation => {
    return toSnakeCase<ApiInvitation>(invitation);
};

export const mapInvitationRedirectToApi = (invitationRedirect: InvitationRedirect): ApiInvitationRedirect => {
    return toSnakeCase<ApiInvitationRedirect>(invitationRedirect);
};

export const mapEmailInvitationToApi = (emailInvitation: EmailInvitation): ApiEmailInvitation => {
    return toSnakeCase<ApiEmailInvitation>(emailInvitation);
};
